import { CalendarDays, Copyright, Globe2, MapPinned } from 'lucide-react';

interface StatusBarProps {
  locationText: string;
  dataUpdateText: string;
  mapProviderText: string;
  copyrightText: string;
}

export function StatusBar({ locationText, dataUpdateText, mapProviderText, copyrightText }: StatusBarProps) {
  return (
    <footer className="status-bar">
      <div className="status-left">
        <span className="status-item">
          <MapPinned size={13} strokeWidth={2.2} />
          {locationText}
        </span>
        <span className="status-item">
          <CalendarDays size={13} strokeWidth={2.2} />
          {dataUpdateText}
        </span>
      </div>

      <div className="status-right">
        <Globe2 size={13} strokeWidth={2.2} />
        <div className="status-copy">{mapProviderText}</div>
      </div>

      <div className="status-right">
        <Copyright size={13} strokeWidth={2.2} />
        <span className="status-copy">{copyrightText}</span>
      </div>
    </footer>
  );
}
